import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_BIOMAS,
  API_CRIAR_CLASSES_BIOMAS,
  API_EXCLUIR_CLASSES_BIOMAS,
  API_ATUALIZAR_CLASSES_BIOMAS } from 'store/modules/api/biomas.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_BIOMAS.success:
      return payload.sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_CLASSES_BIOMAS.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_CLASSES_BIOMAS.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_CLASSES_BIOMAS.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_BIOMAS)

const isSaving = loadingReducer(false, API_CRIAR_CLASSES_BIOMAS)
const isUpdate = loadingReducer(false, API_ATUALIZAR_CLASSES_BIOMAS)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
